import type {
  BlockLayoutName,
  BlockThemeColor,
} from '@/app/[locale]/[year]/blocks/BlockLayout'

export type ColorList = '#FFF166' | '#266782' | '#AADBD7' | '#F3F3F2'
export type StoryLayoutKind = 'layoutA' | 'layoutB' | 'layoutC'

export const mapColorlistToColor = (color?: ColorList): BlockThemeColor => {
  switch (color) {
    case '#FFF166':
      return 'yellow'
    case '#AADBD7':
      return 'teal'
    case '#F3F3F2':
      return 'gray'
    default:
      return 'blue'
  }
}

export const mapStoryLayoutToBlockLayout = (
  layout?: StoryLayoutKind,
): BlockLayoutName => {
  switch (layout) {
    case 'layoutB':
      return 'narrow'
    default:
      return 'default'
  }
}
